var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('main',{staticClass:"main box1200"},[_c('div',{staticClass:"content-container",attrs:{"id":"resultDiag"}},[_c('router-view'),_c('div',{staticClass:"footer"},[_vm._v("本服务由甘肃省白银市提供")])],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"banner-content box1200"},[_c('h1',[_vm._v("会宁县公交站点信息查询")])])])
}]

export { render, staticRenderFns }